@if (alert$ | async; as alert) {
  <div class="alert" [ngClass]="alert.type">
    <span>{{ alert.message }}</span>
    <button (click)="closeAlert()">×</button>
  </div>
}
